<!--
* 组件名 : 切换动画
* 开发者 : LH
-->
<template>
  <transition
    @before-enter="before_enter"
    @enter="enter"
    @after-enter="after_enter"
    @before-leave="before_leave"
    @leave="leave"
    @after-leave="after_leave"
  >
    <slot />
  </transition>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import slideDownIn from "./slideDownIn";
import scrollNext from "./scrollNext";
export default {
  computed: {
    ...mapState("global", ["scrollNextAnimate"]),
  },
  methods: {
    ...mapMutations("global", ["updateScrollNextAnimate"]),
    before_enter(el) {
      this.$P.$emit("page-change-start");
      if (this.scrollNextAnimate) {
        scrollNext.before_enter(el);
      } else {
        slideDownIn.before_enter(el);
      }
    },
    enter(el, done) {
      if (this.scrollNextAnimate) {
        scrollNext.enter(el, done);
      } else {
        slideDownIn.enter(el, done);
      }
    },
    after_enter(el) {
      if (this.scrollNextAnimate) {
        scrollNext.after_enter(el);
      } else {
        slideDownIn.after_enter(el);
      }
      this.$P.$emit("page-change-started");
    },
    before_leave(el) {
      if (this.scrollNextAnimate) {
        scrollNext.before_leave(el);
      } else {
        slideDownIn.before_leave(el);
      }
    },
    leave(el, done) {
      if (this.scrollNextAnimate) {
        scrollNext.leave(el, done);
      } else {
        slideDownIn.leave(el, done);
      }
    },
    after_leave(el) {
      if (this.scrollNextAnimate) {
        scrollNext.after_leave();
      } else {
        slideDownIn.after_leave();
      }
      this.updateScrollNextAnimate(false);
      this.$P.$emit("page-change-ended");
      $(window).trigger("page-change-ended");
    },
  },
};
</script>
